export default __webpack_public_path__ + "static/media/noDashboards.568f3a23.svg";